import { Query } from 'graphql/generated/graphqlTypes';
import { generateMockDoor } from 'mocks/graphqlMocks/door';
import { mockVisitorsWithGroups } from 'mocks/graphqlMocks/visitorFixtures';

export function mockedGetVisitorsAccessEventsFiltersData(
  getDoorsForTenant: Query['getDoorsForTenant'],
  getVisitors: Query['getVisitors']
): Pick<Query, 'getDoorsForTenant' | 'getVisitors'> {
  return {
    getDoorsForTenant,
    getVisitors
  };
}

export const mockedGetVisitorsAccessEventsFiltersDataForQuery = mockedGetVisitorsAccessEventsFiltersData(
  [
    generateMockDoor({
      id: 'mockedDoorId1',
      name: 'Mock Door 1'
    })
  ],
  mockVisitorsWithGroups
);
